import { render } from "./question-modal.vue?vue&type=template&id=72a82958"
import script from "./question-modal.vue?vue&type=script&lang=js"
export * from "./question-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__